__webpack_require__.p = "https://msoffice.usable.dev/powerpoint/";